// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"
import Element, {Upload} from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import cookies from 'vue-cookies'
import "babel-polyfill"
import axios from "axios"
import store from "./store"
import vcolorpicker from "vcolorpicker"

import "./assets/zTree_v3/css/zTreeStyle/zTreeStyle.css"
import "./assets/zTree_v3/js/jquery.ztree.all.js"
import "./assets/zTree_v3/js/jquery.ztree.exhide.min.js"

import "./assets/pulg/jquery-confirm.css"
import "./assets/pulg/jquery-confirm.js"

import i18n from './tools/i18n'
import instance from "./axios.config"


Vue.prototype.globalClick = function (callback) { // 页面全局点击
  $(document).click(callback)
}
Vue.prototype.$ajax = instance// 把axios添加到vue的原型链上
Vue.prototype.$cookies = cookies;

Vue.config.productionTip = false
Vue.use(Element)
Vue.use(Upload)
Vue.use(vcolorpicker)


Vue.prototype.$elementMessage = function (msg, t) {
  this.$message({
    message: msg,
    type: t,
    duration: 1000
  })

}
Vue.prototype.url = window.location.origin + "/"
Vue.prototype.USER_NAME = 0


Array.prototype.remove = function (val) {
  var index = this.indexOf(val)
  if (index > -1) {
    this.splice(index, 1)
  }
}
axios.get("/etv/getServerState.json").then((res) => {
  if (res.data.code === 0) {
    Vue.prototype.USER_NAME = parseInt(res.data.data)
  }
})


router.beforeEach((to, from, next) => {
  Vue.prototype.upFileUrl = localStorage.getItem("upFileUrl") || "/";
  const level = localStorage.getItem("roleId")
  if (to.path === "/system/index" && level !== '1') {
    next('/system/logmana')
  }
  const login = localStorage.getItem("token1")
  if (to.name === "login" && login) {
    next("/terminal")
  }


  if (to.path === "/preview" || to.path === "/myExplain" || to.path === '/resetPwd') {
    next()
  } else if (!login && to.path !== "/login" && to.path !== "/myExplain") {
    next("/login")
  } else {
    next()
    $(".nav-list > li").css({
      background: "#044184",
      color: "#ffffff",
      fontWeight: "100"
    })
    if (to.path.includes("terminal")) {
      $(".nav1").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (to.path.includes("material")) {
      $(".nav5").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (to.path.includes("program")) {
      $(".nav2").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (to.path.includes("system")) {
      $(".nav4").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (to.path.includes("task")) {
      $(".nav3").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (to.path.includes("management")) {
      $(".nav6").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    }
  }

  /*
 //路由拦截没有登陆的用户强行查看页面
*/
})

const vm = new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: {App},
  template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js